module.exports = __webpack_public_path__ + "static/media/logo-ALS-center.c9b60286.svg";